import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  fragment CheckoutFragment on Checkout {\n    id\n    webUrl\n    totalTax\n    lineItemsSubtotalPrice {\n      amount\n      currencyCode\n    }\n    subtotalPriceV2 {\n      amount\n      currencyCode\n    }\n    totalPriceV2 {\n      amount\n      currencyCode\n    }\n    note\n    discountApplications(first: 1) {\n      edges {\n        node {\n          allocationMethod\n          targetSelection\n          targetType\n          value\n        }\n      }\n    }\n    customAttributes {\n      key\n      value\n    }\n    lineItems(first: 250) {\n      edges {\n        node {\n          customAttributes {\n            key\n            value\n          }\n          discountAllocations {\n            allocatedAmount {\n              amount\n              currencyCode\n            }\n            discountApplication {\n              allocationMethod\n              targetSelection\n              targetType\n              value\n            }\n          }\n          id\n          title\n          variant {\n            id\n            title\n            sku\n            image {\n              src\n            }\n            priceV2 {\n              currencyCode\n              amount\n            }\n            preorderDate: metafield(namespace: "gsmeta", key: "preorder_date") {\n              value\n            }\n            product {\n              id\n              handle\n              vendor\n            }\n          }\n          quantity\n        }\n      }\n    }\n  }\n'], ['\n  fragment CheckoutFragment on Checkout {\n    id\n    webUrl\n    totalTax\n    lineItemsSubtotalPrice {\n      amount\n      currencyCode\n    }\n    subtotalPriceV2 {\n      amount\n      currencyCode\n    }\n    totalPriceV2 {\n      amount\n      currencyCode\n    }\n    note\n    discountApplications(first: 1) {\n      edges {\n        node {\n          allocationMethod\n          targetSelection\n          targetType\n          value\n        }\n      }\n    }\n    customAttributes {\n      key\n      value\n    }\n    lineItems(first: 250) {\n      edges {\n        node {\n          customAttributes {\n            key\n            value\n          }\n          discountAllocations {\n            allocatedAmount {\n              amount\n              currencyCode\n            }\n            discountApplication {\n              allocationMethod\n              targetSelection\n              targetType\n              value\n            }\n          }\n          id\n          title\n          variant {\n            id\n            title\n            sku\n            image {\n              src\n            }\n            priceV2 {\n              currencyCode\n              amount\n            }\n            preorderDate: metafield(namespace: "gsmeta", key: "preorder_date") {\n              value\n            }\n            product {\n              id\n              handle\n              vendor\n            }\n          }\n          quantity\n        }\n      }\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  mutation checkoutDiscountCodeApplyV2(\n    $checkoutId: ID!\n    $discountCode: String!\n  ) {\n    checkoutDiscountCodeApplyV2(\n      checkoutId: $checkoutId\n      discountCode: $discountCode\n    ) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n'], ['\n  mutation checkoutDiscountCodeApplyV2(\n    $checkoutId: ID!\n    $discountCode: String!\n  ) {\n    checkoutDiscountCodeApplyV2(\n      checkoutId: $checkoutId\n      discountCode: $discountCode\n    ) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  mutation checkoutDiscountCodeRemove($checkoutId: ID!) {\n    checkoutDiscountCodeRemove(checkoutId: $checkoutId) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n'], ['\n  mutation checkoutDiscountCodeRemove($checkoutId: ID!) {\n    checkoutDiscountCodeRemove(checkoutId: $checkoutId) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  mutation checkoutCreate($input: CheckoutCreateInput!) {\n    checkoutCreate(input: $input) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n'], ['\n  mutation checkoutCreate($input: CheckoutCreateInput!) {\n    checkoutCreate(input: $input) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  mutation checkoutLineItemsReplace(\n    $checkoutId: ID!\n    $lineItems: [CheckoutLineItemInput!]!\n  ) {\n    checkoutLineItemsReplace(checkoutId: $checkoutId, lineItems: $lineItems) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n'], ['\n  mutation checkoutLineItemsReplace(\n    $checkoutId: ID!\n    $lineItems: [CheckoutLineItemInput!]!\n  ) {\n    checkoutLineItemsReplace(checkoutId: $checkoutId, lineItems: $lineItems) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  mutation checkoutLineItemsUpdate(\n    $checkoutId: ID!\n    $lineItems: [CheckoutLineItemUpdateInput!]!\n  ) {\n    checkoutLineItemsUpdate(checkoutId: $checkoutId, lineItems: $lineItems) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n'], ['\n  mutation checkoutLineItemsUpdate(\n    $checkoutId: ID!\n    $lineItems: [CheckoutLineItemUpdateInput!]!\n  ) {\n    checkoutLineItemsUpdate(checkoutId: $checkoutId, lineItems: $lineItems) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  mutation checkoutLineItemsRemove($checkoutId: ID!, $lineItemIds: [ID!]!) {\n    checkoutLineItemsRemove(\n      checkoutId: $checkoutId\n      lineItemIds: $lineItemIds\n    ) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n'], ['\n  mutation checkoutLineItemsRemove($checkoutId: ID!, $lineItemIds: [ID!]!) {\n    checkoutLineItemsRemove(\n      checkoutId: $checkoutId\n      lineItemIds: $lineItemIds\n    ) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  mutation checkoutCustomerAssociate(\n    $checkoutId: ID!\n    $customerAccessToken: String!\n  ) {\n    checkoutCustomerAssociate(\n      checkoutId: $checkoutId\n      customerAccessToken: $customerAccessToken\n    ) {\n      userErrors {\n        field\n        message\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n'], ['\n  mutation checkoutCustomerAssociate(\n    $checkoutId: ID!\n    $customerAccessToken: String!\n  ) {\n    checkoutCustomerAssociate(\n      checkoutId: $checkoutId\n      customerAccessToken: $customerAccessToken\n    ) {\n      userErrors {\n        field\n        message\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  mutation checkoutAttributesUpdateV2(\n    $checkoutId: ID!\n    $input: CheckoutAttributesUpdateV2Input!\n  ) {\n    checkoutAttributesUpdateV2(checkoutId: $checkoutId, input: $input) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n'], ['\n  mutation checkoutAttributesUpdateV2(\n    $checkoutId: ID!\n    $input: CheckoutAttributesUpdateV2Input!\n  ) {\n    checkoutAttributesUpdateV2(checkoutId: $checkoutId, input: $input) {\n      userErrors {\n        message\n        field\n      }\n      checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ', '\n']);

import gql from 'graphql-tag';

import { createLineItems, checkIfItemIsInCart, sendProductToTrackers } from './Utils/CartUtils';

var CheckoutFragment = gql(_templateObject);

export var checkoutDiscountCodeApplyV2 = gql(_templateObject2, CheckoutFragment);

export var checkoutDiscountCodeRemove = gql(_templateObject3, CheckoutFragment);

export var createCheckout = gql(_templateObject4, CheckoutFragment);

export var checkoutLineItemsReplace = gql(_templateObject5, CheckoutFragment);

export var checkoutLineItemsUpdate = gql(_templateObject6, CheckoutFragment);

export var checkoutLineItemsRemove = gql(_templateObject7, CheckoutFragment);

export var checkoutCustomerAssociate = gql(_templateObject8, CheckoutFragment);

export var checkoutAttributesUpdateV2 = gql(_templateObject9, CheckoutFragment);

export function addCheckoutNote(note) {
  var _this = this;

  this.props.checkoutAttributesUpdateV2({
    variables: {
      checkoutId: this.state.checkout.id,
      input: {
        note: note
      }
    }
  }).then(function (res) {
    localStorage.setItem('dormify_checkout_note', note);
    _this.setState({
      checkout: res.data.checkoutAttributesUpdateV2.checkout
    });
  });
}

export function addDiscountCode(code, callback) {
  var _this2 = this;

  this.props.checkoutDiscountCodeApplyV2({
    variables: {
      checkoutId: this.state.checkout.id,
      discountCode: code
    }
  }).then(function (res) {
    localStorage.setItem('dormify_checkout_discount_code', code);
    _this2.setState({
      checkout: res.data.checkoutDiscountCodeApplyV2.checkout
    }, function () {
      if (callback) {
        callback(res.data.checkoutDiscountCodeApplyV2.userErrors);
      }
    });
  });
}

export function removeDiscountCode() {
  var _this3 = this;

  this.props.checkoutDiscountCodeRemove({
    variables: {
      checkoutId: this.state.checkout.id
    }
  }).then(function (res) {
    _this3.setState({
      checkout: res.data.checkoutDiscountCodeRemove.checkout
    });
  });
}

export function addPlusReleaseDate(date) {
  var _this4 = this;

  var customAttributes = [];
  if (date !== null) {
    customAttributes = [{
      key: 'release_date',
      value: date
    }];
  }

  this.props.checkoutAttributesUpdateV2({
    variables: {
      checkoutId: this.state.checkout.id,
      input: {
        customAttributes: customAttributes
      }
    }
  }).then(function (res) {
    if (date !== null) localStorage.setItem('dormify_checkout_plus_release', date);
    _this4.setState({
      checkout: res.data.checkoutAttributesUpdateV2.checkout
    });
  });
}

export function addVariantToCart(items, callback) {
  var _this5 = this;

  var lineItems = createLineItems(this.state.checkout.lineItems.edges);
  var oldLineItems = this.state.checkout.lineItems.edges;

  items.map(function (item) {
    var variantAlreadyInCart = checkIfItemIsInCart(item, lineItems);
    if (variantAlreadyInCart) {
      variantAlreadyInCart.quantity += item.quantity;
    } else {
      item.customAttributes.push({ key: '_addedAt', value: new Date() });
      lineItems.push(item);
    }
  });

  this.props.checkoutLineItemsReplace({
    variables: {
      checkoutId: this.state.checkout.id,
      lineItems: lineItems
    }
  }).then(function (res) {
    _this5.setState({
      checkout: res.data.checkoutLineItemsReplace.checkout
    }, function () {
      var newLineItems = res.data.checkoutLineItemsReplace.checkout.lineItems.edges;
      _this5.handleCartOpen();
      if (callback) {
        callback();
      }
      _this5.updateCartQuantity();
      sendProductToTrackers(oldLineItems, newLineItems);
    });
  });
}

export function updateLineItemInCart(lineItemId, quantity) {
  var _this6 = this;

  this.props.checkoutLineItemsUpdate({
    variables: {
      checkoutId: this.state.checkout.id,
      lineItems: [{
        id: lineItemId,
        quantity: parseInt(quantity, 10)
      }]
    }
  }).then(function (res) {
    _this6.setState({
      checkout: res.data.checkoutLineItemsUpdate.checkout
    }, function () {
      _this6.updateCartQuantity();
    });
  });
}

export function removeLineItemInCart(lineItemId) {
  var _this7 = this;

  this.props.checkoutLineItemsRemove({
    variables: {
      checkoutId: this.state.checkout.id,
      lineItemIds: [lineItemId]
    }
  }).then(function (res) {
    _this7.setState({
      checkout: res.data.checkoutLineItemsRemove.checkout
    }, function () {
      _this7.updateCartQuantity();
    });
  });
}

export function updateCartQuantity() {
  var cartQuantity = 0;
  var newCartItems = [];
  this.state.checkout.lineItems.edges.map(function (line_item) {
    var customAttributes = line_item.node.customAttributes.map(function (attribute) {
      return { key: attribute.key, value: attribute.value };
    });
    var item = {
      variantId: line_item.node.variant.id,
      quantity: line_item.node.quantity,
      customAttributes: customAttributes
    };
    newCartItems.push(item);
    cartQuantity += line_item.node.quantity;
  });
  localStorage.setItem('dormify_checkout_items', JSON.stringify(newCartItems));
  this.setState({
    cartQuantity: cartQuantity
  });
}

export function associateCustomerCheckout(customerAccessToken) {
  var _this8 = this;

  this.props.checkoutCustomerAssociate({
    variables: {
      checkoutId: this.state.checkout.id,
      customerAccessToken: customerAccessToken
    }
  }).then(function (res) {
    _this8.setState({
      checkout: res.data.checkoutCustomerAssociate.checkout,
      isCustomerAuthOpen: false
    });
  });
}